import { EVENT_MAP, eventMinute } from "@/lib/events";

const COLS = ["golo", "autogolo", "falta", "amarelo", "ca_por_exibir", "vermelho", "cv_por_exibir", "pp", "pp_por_assinalar", "vantagem", "outros"];

export const playerSummary = (m) => {
  const rows = {};
  const row = (team, n) => (rows[`${team}-${n}`] ||= { team, number: n, counts: {}, in: null, out: null });
  m.events.forEach((e) => {
    if (e.target_type !== "player" || !e.team || !e.target) return;
    if (e.type === "substituicao") {
      row(e.team, e.target).out = eventMinute(e, m.half2_reset);
      if (e.player_in) row(e.team, e.player_in).in = eventMinute(e, m.half2_reset);
      return;
    }
    const r = row(e.team, e.target);
    r.counts[e.type] = (r.counts[e.type] || 0) + 1;
  });
  const list = Object.values(rows).sort((a, b) => (a.team === b.team ? +a.number - +b.number : a.team === "home" ? -1 : 1));
  const cols = COLS.filter((k) => list.some((r) => r.counts[k])).map((k) => EVENT_MAP[k]);
  return { cols, rows: list };
};
